import { BirthdayFormutil } from 'components/forms/PersonalInfo/components/Birthday';
import { RealNameInfoFormutil } from 'components/forms/RealNameInfo';
import { TaxCountryFormutil } from 'components/forms/TaxCountry';
import { TaxNumberFormutil } from 'components/forms/TaxNumber';
import { BeneficiaryRelationshipEnum, BeneficiaryTypeEnum } from 'types/customer';

export interface BeneficiaryDataItem
    extends RealNameInfoFormutil,
        BirthdayFormutil,
        TaxNumberFormutil,
        TaxCountryFormutil {
    beneficiary_relationship: BeneficiaryRelationshipEnum;
    percentage: string;
    beneficiary_type: BeneficiaryTypeEnum;
}

export interface BeneficiaryInfoFormutil {
    temporaryPrimaryBeneficiary?: BeneficiaryDataItem[];
    temporarySecondaryBeneficiary?: BeneficiaryDataItem[];
}
